import { Component } from '@angular/core';
import { NavController, NavParams, ToastController, AlertController, LoadingController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Globals } from "../../../../globals";
import { ConfigurationServices } from "../../services";
import { AngularFireAuth } from "angularfire2/auth";
import { AuthServices } from "../../../auth/services";
import { HTTP } from '@ionic-native/http';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the ConfigurationRoomsCreatePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-configuration-users-create',
  templateUrl: 'configuration-users-create.html',
})
export class ConfigurationUsersCreatePage {

  public form: FormGroup;
  public user: any;
  update_state: boolean = false;
  loadingPopup: any;
  change_rol: boolean = true;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public fb: FormBuilder,
    private toastCtrl: ToastController,
    public globals: Globals,
    private alertCtrl: AlertController,
    public configurationServices: ConfigurationServices,
    private afAuth: AngularFireAuth,
    public authServices: AuthServices,
    private http: HTTP,
    public loadingCtrl: LoadingController,
    public translate: TranslateService) {

    this.globals.GAtrackView('Configuration', 'Configuration - User - View ', this.globals.restaurant.email, 'View', 'View user', 'Configuration', '');

    //Params
    this.update_state = this.navParams.get('update_state');

    this.loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });

    if (this.navParams.get('update_state')) {
      this.user = this.navParams.get('user');
      this.form = fb.group({
        name: [this.user.name, Validators.compose([Validators.required])],
        email: [this.user.email],
        rol: [this.user.restaurants[this.user.key].rol],
      });
      //get tables
    } else {
      this.form = this.fb.group({
        name: [''],
        email: ['', Validators.compose([Validators.required])],
        rol: ['', Validators.compose([Validators.required])],
        password: ['', Validators.compose([Validators.required])],
        password_repeat: ['', Validators.compose([Validators.required])],
      });
    }
  }

  ionViewWillEnter() {
    //si el email del usuario es el mismo que el email del restaurante, deshabilitamos la edicion del rol
    if (this.user != undefined && this.globals.restaurant.email == this.user.email) {
      document.getElementById('rol_select').setAttribute('disabled', '');
      this.change_rol = false;
    }
  }


  /*private MatchPassword(AC: AbstractControl) {
    const newPassword = AC.get('password').value;// to get value in input tag
    const confirmPassword = AC.get('password_confirmation').value;// to get value in input tag
    if (newPassword != confirmPassword) {
      AC.get('password_confirmation').setErrors({ MatchPassword: true })
    } else {
      AC.get('password_confirmation').setErrors(null);
    }
  }*/

  error_password_message: string = '';
  _send_form: boolean = false;
  checkPasswordU() {
    if (this.form.value.password.length < 7) {
      this._send_form = false;
      this.error_password_message = this.translate.instant('config-users-create-min-chars-contrasena');
    } else if (this.form.value.password == this.form.value.password_repeat) {
      this._send_form = true;
      this.error_password_message = '';
    } else {
      this._send_form = false;
      this.error_password_message = this.translate.instant('config-users-create-contrasenas-no-iguales');
    }
  }

  submit() {
    if (this.form.valid) {
      if (!this.update_state) {
        this.insert();
      } else {
        this.update();
      }
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-introduce-email-contrasena'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  insert() {
    /*CREAR USER EN FirebBase*/
    this.loadingPopup.present();

    this.http.post(this.globals.analytics_path + 'users/create', {
      email: this.form.value.email,
      password: this.form.value.password
    }, {})
      .then(async response => {
        var data = JSON.parse(response.data);
        await this.authServices.createUserRestaurantConfiguration(this.form.value.email, this.form.value.name, data.uid_user,
          this.globals.restaurant_uid, this.form.value.rol);
        this.loadingPopup.dismiss();
        this.globals.GAtrackView('Configuration', 'Configuration - User - Create ', this.globals.restaurant.email, 'Create/Update', 'Create user', 'Configuration', this.form.value.email);
        this.navCtrl.pop();
        //this.initRestaurantData();
      })
      .catch(error => {
        this.addRestToUser();
      });
  }

  async addRestToUser() {
    //recuperar user
    var _user = await this.configurationServices.getUser(this.form.value.email);
    //comprovar que en el usuario no exista el restaurante
    var _existeix = false;
    for (let key in _user.restaurants) {
      if (_user.restaurants[key].UID_RESTAURANT == this.globals.restaurant_uid) {
        _existeix = true;
      }
    }
    //
    if (_existeix) {
      this.loadingPopup.dismiss();
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-usuario-tiene-rol-restaurante'),
        duration: 3000,
        position: 'top'
      });
      toast.present();
    } else {
      var restaurants = _user.restaurants;
      //mirar ultim index
      var last_key = Object.keys(restaurants)[Object.keys(restaurants).length - 1];
      if (last_key == undefined) {
        last_key = '-1';//Iniciamos a 0 si esta undefined
      }

      restaurants[Number(last_key) + 1] = {
        'UID_RESTAURANT': this.globals.restaurant_uid,
        'rol': this.form.value.rol
      }

      //insertar rest
      this.configurationServices.afs.collection('users').doc(_user.UID).update({
        'restaurants': restaurants,
      }).then(() => {
        this.loadingPopup.dismiss();
        let toast = this.toastCtrl.create({
          message: this.translate.instant('instant-usuario-creado-correctamente'),
          duration: 3000,
          position: 'top'
        });
        toast.present();
        this.globals.GAtrackView('Configuration', 'Configuration - User - Create ', this.globals.restaurant.email, 'Create/Update', 'Create user', 'Configuration', this.form.value.email);
        this.navCtrl.pop();
      });
    }
  }

  resetPassword() {

    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-enviando-nueva-contrasena')
    });
    loadingPopup.present();
    //enviar peticion FirebBase
    this.afAuth.auth.sendPasswordResetEmail(this.form.value.email).then(_ => {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-email-enviado-reinicio-contrasena') + ": " + this.form.value.email,
        duration: 3000,
        position: 'top'
      });
      toast.present();
      loadingPopup.dismiss();
    });


    /*this.navCtrl.push(PasswordRecoveryPage, {
      'email': this.form.value.email,
    })*/
  }

  async update() {
    this.loadingPopup.present();
    var _user = await this.configurationServices.getUser(this.form.value.email);

    for (let key in _user.restaurants) {
      if (_user.restaurants[key].UID_RESTAURANT == this.globals.restaurant_uid) {
        _user.restaurants[key].rol = this.form.value.rol;
      }
    }

    this.configurationServices.afs.collection('users').doc(_user.UID).update({
      'email': this.form.value.email,
      'name': this.form.value.name,
      'restaurants': _user.restaurants,
    }).then(() => {
      //this.user = this.configurationServices.getUser(this.form.value.email);
      this.globals.user_name = this.form.value.name;
      this.loadingPopup.dismiss();
      this.globals.getUsers();
      this.globals.GAtrackView('Configuration', 'Configuration - User - Update', this.globals.restaurant.email, 'Create/Update', 'Update user', 'Configuration', this.form.value.email);
      this.navCtrl.pop();

    });
  }

  delete() {
    //eliminar rest de restaurants del usuario (array)
    let alert = this.alertCtrl.create({
      title: this.translate.instant('instant-eliminar-usuario'),
      message: this.translate.instant('instant-seguro-quieres-eliminar-usuario'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            //convert to array
            let arr = [];
            for (let k in this.user.restaurants) {
              arr.push(this.user.restaurants[k]);
            }
            //delete
            arr.splice(this.user.key, 1);

            //create of array to object
            const obj = {};
            arr.forEach((item, index) => {
              obj[index] = item;
            })
            this.user.restaurants = obj;

            //elimina de global users el usuario eliminado
            for (var i = this.globals.users.length - 1; i >= 0; --i) {
              if (this.globals.users[i].UID == this.user.UID) {
                this.globals.users.splice(i, 1);
              }
            }

            //no hi ha res dins object reiniciar
            if (Object.keys(this.user.restaurants).length == 0) {
              this.user.restaurants = {};
            }

            //update para que quede eliminado
            this.configurationServices.afs.collection('users').doc(this.user.UID).update({
              'restaurants': this.user.restaurants,
            }).then(() => {
              this.globals.getUsers();
              this.navCtrl.pop();
            });
          }
        }
      ]
    });
    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-users/configuration-users-create/configuration-users-create.ts